"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = exports.StyledChip = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledChip = styled_components_1.default.label `
  ${(props) => props.theme.font.size.s};
  border-radius: 100px;
  min-width: 96px;
  display: inline-block;
  text-align: center;
  padding: 4px 10px;
  margin: 2px;
  ${(props) => props.variant === 'primary' &&
    `
    background-color: ${props.theme.colors.primaryAccent};
    color: ${props.theme.colors.white};
  `}
  ${(props) => props.variant === 'active' &&
    `
    background-color: ${props.theme.colors.secondaryAccent};
    color: ${props.theme.colors.white};
  `}
    ${(props) => props.variant === 'warning' &&
    `
    background-color: ${props.theme.colors.warning};
    color: ${props.theme.colors.black};
  `}
    ${(props) => props.variant === 'error' &&
    `
    background-color: ${props.theme.colors.error};
    color: ${props.theme.colors.white};
  `}
    ${(props) => props.variant === 'grey' &&
    `
    background-color: ${props.theme.colors.borderDefault};
    color: ${props.theme.colors.textInput};
  `};
`;
const Chip = ({ className, id, style, label, color, backgroundColor, variant, }) => (react_1.default.createElement(exports.StyledChip, { className: className, id: id, style: Object.assign({ color, backgroundColor }, style), variant: variant, label: label }, label));
exports.Chip = Chip;
exports.default = exports.Chip;
